import { useQueryClient } from '@tanstack/react-query';
import klydoApiClient from '../../../api/klydo';
import useKlydoMutation, {
  UseKlydoMutationOptions,
} from '../../../hooks/useKlydoMutation';

export type UseWithdrawKlydoMutationParams = {
  klydoId: string;
};

const useWithdrawKlydoMutation = (
  options?: UseKlydoMutationOptions<void, UseWithdrawKlydoMutationParams, void>,
) => {
  const queryClient = useQueryClient();

  // No success toast on purpose: the design clears the toast for this action —
  // the status row flipping to "Not public" is the confirmation. Errors still
  // alert, via useKlydoMutation.
  return useKlydoMutation({
    mutationKey: ['withdraw-klydo'],
    mutationFn: ({ klydoId }) => {
      return klydoApiClient.withdrawKlydo(klydoId);
    },
    onSettled: (data, error, { klydoId }) => {
      queryClient.invalidateQueries({ queryKey: ['klydo', klydoId] });
      queryClient.invalidateQueries({ queryKey: ['klydosList'] });
    },
    ...options,
  });
};

export default useWithdrawKlydoMutation;
